/** 和日常生产有关的接口 **/
import request from '../index';
/** 
* AbnormalProblemHandle
* @params {string} data.componentCode 部件编码
* @params {string} data.componentName 部件名称
* @params {string} data.handlingMeasures 处理措施
* @params {number} data.id 
* @params {string} data.localDate 日期
* @params {string} data.notes 备注
* @params {string} data.picture 图片
* @params {string} data.problem 问题
* @params {string} data.processType 处理类型:单点解决/工序停产整改/截流停产整改
* @params {string} data.project 项目
* @params {string} data.reason 原因
* @params {string} data.status 状态:整改完毕/未完成
* @params {string} data.type 类型
* @params {number} data.userId 
* @params {string} data.username 
* @params {string} data.video 视频
*/

/** 
* CapacitySpotCheck
* @params {number} data.currentCompletedNumber 当前完成数量
* @params {string} data.employeeAttitude 员工态度:诚恳/勉强接受/不接受
* @params {string} data.firstConfirm 首样确认:合格/不合格
* @params {number} data.id 
* @params {boolean} data.isEducation 批评教育:是/否
* @params {boolean} data.isTrain 培训:是/否
* @params {string} data.localDate 日期
* @params {number} data.plannedNumber 计划数量
* @params {string} data.progressEvaluation 进度评估:达标/未达标
* @params {string} data.project 项目
* @params {string} data.reason 原因
* @params {string} data.spotCheckContent 抽查内容
* @params {string} data.spotCheckPerson 抽查组员
* @params {string} data.type 类型
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* ProcessChange
* @params {string} data.changeContent 变更内容
* @params {number} data.id 
* @params {boolean} data.isGroupLeaderFirstConfirm 组长首样确认
* @params {boolean} data.isGroupMembersFirstConfirm 组员首样确认
* @params {boolean} data.isGroupMembersQualitySpotCheck 组员质量抽查
* @params {boolean} data.isGroupMembersSecondaryTrain 组员二次培训
* @params {string} data.localDate 日期
* @params {string} data.project 项目
* @params {string} data.type 类型
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* QualitySpotCheck
* @params {string} data.employeeAttitude 员工态度:诚恳/勉强接受/不接受
* @params {string} data.firstConfirm 首样确认:合格/不合格
* @params {number} data.id 
* @params {boolean} data.isEducation 批评教育:是/否
* @params {boolean} data.isTrain 培训:是/否
* @params {string} data.localDate 日期
* @params {string} data.picture 图片
* @params {string} data.project 项目
* @params {string} data.reason 原因
* @params {string} data.spotCheckContent 抽查内容
* @params {string} data.spotCheckPerson 抽查组员
* @params {string} data.spotCheckSituation 抽查情况:合格/不合格
* @params {string} data.type 类型
* @params {number} data.userId 
* @params {string} data.username 
* @params {string} data.video 视频
*/

/** 
* StationCheck
* @params {string} data.checkContent 检查内容
* @params {string} data.checkModule 检查模块:区域状态标识/仪器设备/工装工具/在岗/5s/其他违规
* @params {boolean} data.checkResults 检查结果
* @params {string} data.employeeAttitude 员工态度:诚恳/勉强接受/不接受
* @params {number} data.id 
* @params {boolean} data.isEducation 批评教育:是/否
* @params {boolean} data.isTrain 培训:是/否
* @params {string} data.localDate 日期
* @params {string} data.picture 图片
* @params {string} data.project 项目
* @params {string} data.type 类型
* @params {string} data.unqualifiedReason 不合格原因
* @params {number} data.userId 
* @params {string} data.username 
* @params {string} data.video 视频
*/

/** 
* WIRecord
* @params {string} data.contactPerson 工程对接人
* @params {string} data.countermeasures 应对措施
* @params {string} data.feedbackContent 反馈内容
* @params {number} data.id 
* @params {string} data.localDate 日期
* @params {string} data.picture 图片
* @params {string} data.project 项目
* @params {string} data.type 类型
* @params {number} data.userId 
* @params {string} data.username 
* @params {string} data.video 视频
*/

/** 
* 删除异常问题统计和处理
* @params {array} ids
*/
export const deleteAbnormalProblemHandle = (data) => request.delete('/api-qc/deleteAbnormalProblemHandle', data);

/** 
* 删除产能抽查
* @params {array} ids
*/
export const deleteCapacitySpotCheck = (data) => request.delete('/api-qc/deleteCapacitySpotCheck', data);

/** 
* 删除工艺变更
* @params {array} ids
*/
export const deleteProcessChange = (data) => request.delete('/api-qc/deleteProcessChange', data);

/** 
* 删除质量抽查
* @params {array} ids
*/
export const deleteQualitySpotCheck = (data) => request.delete('/api-qc/deleteQualitySpotCheck', data);

/** 
* 删除工位检查
* @params {array} ids
*/
export const deleteStationCheck = (data) => request.delete('/api-qc/deleteStationCheck', data);

/** 
* 删除作业指导书及其记录表反馈
* @params {array} ids
*/
export const deleteWIRecord = (data) => request.delete('/api-qc/deleteWIRecord', data);

/** 
* 获得异常问题统计和处理列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getAbnormalProblemHandleList = (params) => request.get('/api-qc/getAbnormalProblemHandleList', { params });

/** 
* 获得备份文件列表
* @params {string} params.localDate 日期
* @params {string} params.serial 机身号
* @params {string} params.type type
*/
export const getBackupFileList = (params) => request.get('/api-qc/getBackupFileList', { params });

/** 
* 获得备份文件路径
* @params {string} params.serial 机身号
*/
export const getBackupFilePath = (params) => request.get('/api-qc/getBackupFilePath', { params });

/** 
* 获得产能抽查列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getCapacitySpotCheckList = (params) => request.get('/api-qc/getCapacitySpotCheckList', { params });

/** 
* 获得当天半成品工序库存
*/
export const getInventory = (params) => request.get('/api-qc/getInventory', { params });

/** 
* 获得计划半成品
* @params {string} params.endDate 结束时间
* @params {string} params.startDate 开始时间
*/
export const getPlannedSemiFinishedProducts = (params) => request.get('/api-qc/getPlannedSemiFinishedProducts', { params });

/** 
* 获得工艺变更列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getProcessChangeList = (params) => request.get('/api-qc/getProcessChangeList', { params });

/** 
* 获得生产任务列表
* @params {string} params.localDate 日期
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.type 类型
*/
export const getProductionTaskList = (params) => request.get('/api-qc/getProductionTaskList', { params });

/** 
* 获得质量抽查列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getQualitySpotCheckList = (params) => request.get('/api-qc/getQualitySpotCheckList', { params });

/** 
* 获得返修半成品
* @params {string} params.endDate 结束时间
* @params {string} params.startDate 开始时间
*/
export const getRepairSemiFinishedProducts = (params) => request.get('/api-qc/getRepairSemiFinishedProducts', { params });

/** 
* 获得返修任务列表
* @params {string} params.localDate 日期
* @params {string} params.type 类型
*/
export const getRepairTaskList = (params) => request.get('/api-qc/getRepairTaskList', { params });

/** 
* 获得工位检查列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getStationCheckList = (params) => request.get('/api-qc/getStationCheckList', { params });

/** 
* 获得作业指导书及其记录表反馈列表
* @params {string} params.localDate 日期
* @params {string} params.project 项目
* @params {string} params.type 类型
*/
export const getWIRecordList = (params) => request.get('/api-qc/getWIRecordList', { params });

/** 
* 添加或更新异常问题统计和处理
* @params {AbnormalProblemHandle} abnormalProblemHandle
*/
export const saveOrUpdateAbnormalProblemHandle = (data) => request.post('/api-qc/saveOrUpdateAbnormalProblemHandle', data);

/** 
* 添加或更新产能抽查
* @params {CapacitySpotCheck} capacitySpotCheck
*/
export const saveOrUpdateCapacitySpotCheck = (data) => request.post('/api-qc/saveOrUpdateCapacitySpotCheck', data);

/** 
* 添加或更新工艺变更
* @params {ProcessChange} processChange
*/
export const saveOrUpdateProcessChange = (data) => request.post('/api-qc/saveOrUpdateProcessChange', data);

/** 
* 添加或更新质量抽查
* @params {QualitySpotCheck} qualitySpotCheck
*/
export const saveOrUpdateQualitySpotCheck = (data) => request.post('/api-qc/saveOrUpdateQualitySpotCheck', data);

/** 
* 添加或更新返修任务
* @params {array} list
*/
export const saveOrUpdateRepairTask = (data) => request.post('/api-qc/saveOrUpdateRepairTask', data);

/** 
* 添加或更新工位检查
* @params {StationCheck} stationCheck
*/
export const saveOrUpdateStationCheck = (data) => request.post('/api-qc/saveOrUpdateStationCheck', data);

/** 
* 添加或更新作业指导书及其记录表反馈
* @params {WIRecord} wiRecord
*/
export const saveOrUpdateWIRecord = (data) => request.post('/api-qc/saveOrUpdateWIRecord', data);

/** 
* 清空备份文件
* @params {number} params.id id
*/
export const updateBackupFile = (data) => request.put('/api-qc/updateBackupFile', data);

/** 
* 更新生产任务
* @params {string} params.batch 批号
* @params {number} params.currentCompletedNumber 当前完成数量
* @params {number} params.currentCompletedRate 当前完成率
* @params {number} params.currentInspectionNumber 当前送检数量
* @params {number} params.currentQualifiedNumber 当前合格数量
* @params {number} params.id undefined
* @params {number} params.inventoryNotInspectionNumber 库存未检数量
* @params {string} params.localDate 日期
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {number} params.productionInstructionId undefined
* @params {number} params.productionTaskNumber 生产任务数量
* @params {string} params.project 项目:swan 600/swan 600P
* @params {number} params.qualifiedInventoryNumber 库存合格数量
* @params {string} params.type type
* @params {number} params.userId undefined
* @params {string} params.username undefined
*/
export const updateProductionTask = (data) => request.post('/api-qc/updateProductionTask', data);

/** 
* 上传备份文件
* @params {string} params.filePath 文件路径
* @params {number} params.id undefined
* @params {string} params.localDate 日期
* @params {string} params.serial 机身号
* @params {number} params.type 用途：0：生产使用（设备配置文件）、1：售后使用（用户设备数据）
* @params {number} params.uploadNumber 上传次数
*/
export const uploadBackupFile = (data) => request.post('/api-qc/uploadBackupFile', data);

/** 
* 上传日常生产附件
*/
export const uploadProduceAttachment = (data) => request.post('/api-qc/uploadProduceAttachment', data);

